import { DataBox, createDataBox } from 'app/common/data-box-store'
import { AcquiringSettings } from 'app/dataTypes/acquiring/settings'


const defaultAcquiringSettings: AcquiringSettings = {
  primary: new Map(),
  cafeteria: new Map(),
  camp: new Map(),
  availableRefillTypes: [],
}

class AcquiringSettingsDataBox extends DataBox<AcquiringSettings> { }
export const acquiringSettings = createDataBox('acquiringSettings', defaultAcquiringSettings, AcquiringSettingsDataBox)
